import React from 'react';

const EscamboContext = React.createContext({});

export const EscamboProvider = EscamboContext.Provider;
export default EscamboContext;